import { render, staticRenderFns } from "./WhatsAppButtonComponent.vue?vue&type=template&id=075306e2"
import script from "./WhatsAppButtonComponent.vue?vue&type=script&lang=js"
export * from "./WhatsAppButtonComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports